import PartProgressModal from './PartProgressModal';

export default PartProgressModal;
